import InjectionAddressDetails from 'pages/app/addresses/injection-address/InjectionAddressDetails.tsx'
import OfftakeAddressDetails from 'pages/app/addresses/offtake-address/OfftakeAddressDetails.tsx'
import { useStoreSelector } from 'hooks/store.ts'
import { Navigate, useParams } from 'react-router'
import styles from './Addresses.module.scss'
import { FaqSlugB2C } from 'types/faq.ts'
import PageLayout from 'layouts/page-layout/PageLayout.tsx'
import { useTranslation } from 'react-i18next'
import { routes } from 'types/routes.ts'
import { EL_PRODUCT_CODES, ELProduct } from '@boltenergy-be/shared'

const AddressDetail = () => {
  // URL Param
  const { id } = useParams<{ id: string }>()

  // Redux
  const { billingContracts } = useStoreSelector((store) => store.contact)
  const selectedBillingContract = id ? billingContracts?.[id] : undefined

  // i18n
  const { t } = useTranslation('addresses')

  return !selectedBillingContract ? (
    <Navigate to={routes.CONTRACT} replace />
  ) : (
    !!selectedBillingContract && (
      <PageLayout
        title={t(($) => $.myContract.title)}
        classes={{ body: styles['detail-body'] }}
        backButtonUrl={routes.CONTRACT}
        faqCategories={{ b2c: [FaqSlugB2C.MY_ADDRESSES] }}
      >
        {(
          [
            EL_PRODUCT_CODES.BoltInjection,
            EL_PRODUCT_CODES.BoltInjectionOn,
            EL_PRODUCT_CODES.BoltInjectionTa,
            EL_PRODUCT_CODES.Tailored
          ] as ELProduct[]
        ).includes(selectedBillingContract.serviceContracts.electricity.detail.productCode) ? (
          <InjectionAddressDetails contract={selectedBillingContract} />
        ) : (
          <OfftakeAddressDetails contract={selectedBillingContract} />
        )}
      </PageLayout>
    )
  )
}

export default AddressDetail
